import React from "react";

import ContentCore from "../../../../core/workingContent";

import "../../_index.css";

const TaskNewReceiverUI = () => {
  return (
    <>
      <ContentCore />
    </>
  )
}

export default TaskNewReceiverUI;
